import Baobab from 'baobab';

export const state = new Baobab({
  user: null,
  loaders: 0,
  modals: [],
});
